import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SearcherFeatureComponent } from '@vueling-ng/vy-cdk-searcher';
import { CardFeaturedModule } from '@vueling-ng/vy-ds/src/lib/components/composed/card-featured';
import { BadgeModule } from '@vueling-ng/vy-ds/src/lib/components/globals/badge';
import { FloatingMessageModule } from '@vueling-ng/vy-ds/src/lib/components/globals/floating-message';
import { LoaderFullScreenModule } from '@vueling-ng/vy-ds/src/lib/components/globals/loaders/loader-full-screen';
import { ModalModule } from '@vueling-ng/vy-ds/src/lib/components/globals/modal';
import { SidePanelModule } from '@vueling-ng/vy-ds/src/lib/components/globals/side-panel';
import { TableModule } from '@vueling-ng/vy-ds/src/lib/components/globals/table';
import { provideAuth } from 'angular-auth-oidc-client';
import { environment } from 'environments/environment';
import { MarkdownModule } from 'ngx-markdown';
import { Observable } from 'rxjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConfigOidcProvider } from './core/configuration/models/openId.config';
import { AmsAuthInterceptor } from './core/http/auth-interceptor.service';
import { AppInitializerService } from './services/app-initializer.service';
import { AlertBannerModule } from './shared/alerts';
import { BookingDetailModule } from './views/booking-detail/booking-detail.module';
import { BookingListModule } from './views/booking-list/booking-list.module';
import { HomeModule } from './views/home/home.module';
import { PageLayoutModule } from './views/page-layout/page-layout.module';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}

export function initializeApp(initService: AppInitializerService): () => Observable<void> {
  return () => initService.initializeApp();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AlertBannerModule,
    FloatingMessageModule,
    LoaderFullScreenModule,
    CardFeaturedModule,
    TableModule,
    BadgeModule,
    MarkdownModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: environment.internationalization.defaultLanguage
    }),
    HomeModule,
    BookingListModule,
    BookingDetailModule,
    SearcherFeatureComponent,
    EffectsModule.forRoot([]),
    StoreModule.forRoot([]),
    SidePanelModule,
    ModalModule,
    PageLayoutModule
  ],
  providers: [
    AppInitializerService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppInitializerService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AmsAuthInterceptor,
      multi: true
    },
    provideAuth({ config: ConfigOidcProvider })
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
